import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import HairOnboarding from './HairOnboarding';
import {Helmet} from "react-helmet";

import { ChatContainerWrapper } from "../../onboarding/OnboardingStyles";
import { quizStyleHair, quizStyleMobileHair } from '../../../utils/styles';
import Name from '../../onboarding/Name';
import Account from '../../onboarding/Account';
import AthOnboardingMultiple from '../../../ath/components/onboarding/AthOnboardingMultiple';
import AthOnboardingProducts from '../../../ath/components/onboarding/AthOnboardingProducts';
import Picture from '../../onboarding/Picture';
import HairSteps from '../../../components/hair/header/HairStepsHeader';

import * as aaUtil from '../../../ath/utils/aaUtils';

import './HairOnboarding.css';

class HairOnboardingContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stage: 0,
            width: document.documentElement.clientWidth,
            redirectToHome: false
        };

        this.updateStage = this.updateStage.bind(this);
        this.redirectToHome = this.redirectToHome.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleMediaQueries.bind(this), false);
        if (this.props.location.search.includes("gift")) {
            localStorage.setItem("gift_user", true);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleMediaQueries.bind(this), false);
    }

    handleMediaQueries() {
        this.setState({
            width: document.documentElement.clientWidth
        });
    }


    updateStage(stage) {
        this.setState({ stage: stage });
    }

    redirectToHome() {
        this.setState({redirectToHome: true});
    }

    render() {

        const startOfStepsWhenNotSignin =
        [
            {
                id: 'Q0',
                component: (
                  <div>
                  Hey! I'm Ava, your smart hair care consultant. In order to accurately recommend products based on your specific hair needs, I need your permission to share your information with our trusted partner, Unilever.
                  </div>),
                asMessage: true,
                trigger: ({ value, steps }) => {
                    return 'intro-1';
                  }
            },
            {
                id: 'intro-1',
                component: (
                  <div className="second-message">
                  Don’t worry, your data is kept strictly confidential and will not be shared with any third party companies. Are you happy to proceed? (For more information, please refer to their <a target="_blank" className="onboarding-privacy-link" href="https://www.unilevernotices.com/usa/english/privacy-notice/notice.html">Privacy Notice</a>).
                  </div>
                ),
                asMessage: true,
                trigger: ({ value, steps }) => {
                    return 'intro';
                  }
            }, 
            {
                id: 'intro',
                options: [
                    { value: '1', label: 'Yes, I understand', trigger: 'Q1' },
                    { value: '2', label: 'No thanks', trigger: 'Q0-1' }
                ]
            },
            {
                id: 'Q0-1',
                message: 'No worries, we\'ll take you back.',
                end: true
            },
            {
                id: 'Q1',
                message: "That's great - let's get going. What's your name?",
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                        "Intro/privacy question (P2)",
                        steps["intro"].message,
                        "Q0 (P2)"
                      );
                    this.updateStage(1);
                    return 'A1-1';
                }

            },
            {
                id: 'Q1-1',
                message: 'What’s your name?',
                trigger: ({ value, steps }) => {
                    return 'A1-1';
                }

            },
            {
                id: 'A1-1',
                component: <Name answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q2',
            },
            {
                id: 'Q2',
                message: 'What\'s your age group?',
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                        steps["Q1"].message + " (P2)",
                        "Name entered",
                        "Q1 (P2)"
                      );
                    return 'A2';
                }
            },
            {
                id: 'A2',
                options: [
                    { value: '1', label: this.state.width > 813 ? "under 18" : "< 18", trigger: 'Q3-A' },
                    { value: '2', label: "19-25", trigger: 'Q3-A' },
                    { value: '3', label: "26-35", trigger: 'Q3-A' },
                    { value: '4', label: "36-50", trigger: 'Q3-A' },
                    { value: '5', label: "50+", trigger: 'Q3-A' }
                ]
            },
            {
                id: 'Q3-A',
                message: 'What\'s your gender?',
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                        steps["Q2"].message + " (P2)",
                        steps["A2"].message,
                        "Q2 (P2)"
                      );
                    return 'A3-A';
                }

            },
            {
                id: 'A3-A',
                options: [
                    { value: '1', label: "Female", trigger: 'Q4' },
                    { value: '2', label: "Male", trigger: 'Q4' },
                    { value: '3', label: "Prefer not to disclose", trigger: 'Q4' }
                ]
            }
        ];

        const endOfStepsWhenNotSignin =
        [
            {
                id: 'Q9',
                message: "Your product recommendations and hair profile are ready. Document your haircare journey by creating an account with us:",
                trigger: ({ value, steps }) => {
                    aaUtil.event24_view_question(
                        "What would you like your hair routine to be? (P2)",
                        "wash,condition,dry,style,refresh:3",
                        "Q8-9 (P2)"
                      );
                    return 'A9';
                }
            },
            {
                id: 'A9',
                component: <Account ath={true} answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q10'
            },
            {
                id: 'Q10',
                message: "Thank you for completing the detailed evaluation! We are calculating your hair type, regimen, and recommendations now!",
                end: true
            }
        ];

        const startOfStepsWhenSignin =
        [
            {
                id: 'Q1',
                message: "Retaking the quiz will update your existing profile and product recommendations. Does this sound good to you?",
                trigger: 'A1'

            },
            {
                id: 'A1',
                options: [
                    { value: 'yes', label: 'Yes', trigger: 'Q4' },
                    { value: 'no', label: 'No', trigger: 'Q2' }
                ]
            },
            {
                id: 'Q2',
                message: 'No problem. We will direct you to your latest profile and our recommendations.',
                end: true,
                delay: 1000
            }
        ];

        const startOfStepsWhenSigninHaveSkinProfile =
        [
            {
                id: 'Q0',
                component: (
                  <div>
                  Hey! I'm Ava, your smart hair care consultant. In order to accurately recommend products based on your specific hair needs, I need your permission to share your information with our trusted partner, Unilever.
                  </div>),
                asMessage: true,
                trigger: ({ value, steps }) => {
                    // if (!localStorage.getItem("user_has_hair_profile")) {
                    // aaUtil.event24_view_question(
                    //   steps["Q1"].message
                    // );
                    // }
                    return 'intro-1';
                  }
            },
            {
                id: 'intro-1',
                component: (
                  <div className="second-message">
                  Don’t worry, your data is kept strictly confidential and will not be shared with any third party companies. Are you happy to proceed? (For more information, please refer to their <a target="_blank" className="onboarding-privacy-link" href="https://www.unilevernotices.com/usa/english/privacy-notice/notice.html">Privacy Notice</a>).
                  </div>
                ),
                asMessage: true,
                trigger: ({ value, steps }) => {
                    
                    return 'intro';
                  }
            },
            {
                id: 'intro',
                options: [
                    { value: '1', label: 'Yes, I understand', trigger: 'Q4' },
                    { value: '2', label: 'No thanks', trigger: 'Q0-1' }
                ]
            },
            {
                id: 'Q0-1',
                message: 'No worries, we\'ll take you back.',
                end: true
            },
        ];


        const endOfStepsWhenSignin =
        [
            {
                id: 'Q9',
                message: "All done! We will direct you to your latest profile and update our recommendations.",
                end: true,
                delay: 1000
            }
        ];

        const stepsOfSurveyAndSelfie =
        [
            {
                id: 'Q4',
                message: 'What are your primary hair goals?',
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        localStorage.getItem("user_has_skin_profile") ?
                        aaUtil.event24_view_question(
                            "Intro/privacy question (P2)",
                            steps["intro"].message,
                          ) :
                        aaUtil.event24_view_question(
                          steps["Q3-A"].message + " (P2)",
                          steps["A3-A"].message,
                          "Q3 (P2)"
                        );
                      }
                    this.updateStage(2);
                    return 'A4';
                }
            },
            {
                id: 'A4',
                component:<AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                      { key: '1', label: 'Hydration' },
                      { key: '2', label: 'Curl Definition' },
                      { key: '3', label: 'Volume' },
                      { key: '4', label: 'Strength' },
                      { key: '5', label: 'Smoothness' },
                      { key: '6', label: 'Color' },
                      { key: '7', label: 'Protection' },
                      { key: '8', label: 'Shine' },
                      { key: '9', label: 'Frizz Control' },
                      { key: '10', label: 'Dandruff Control' },
                      { key: '11', label: 'Hair Loss Control' }
                  ]
                  }
                />,
                waitAction: true,
                trigger: 'Q4-2'
            },
            {
                id: 'Q4-2',
                message: 'Is your natural hair shape:',
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q4"].message + " (P2)",
                        steps["A4"].value.split(":")[1],
                        "Q4 (P2)"
                        );
                    }
                    return 'A4-2';
                }
            },
            {
                id: 'A4-2',
                options: [
                    { value: '1', label: 'Straight', trigger: 'Q5' },
                    { value: '2', label: 'Wavy', trigger: 'Q5' },
                    { value: '3', label: 'Curly', trigger: 'Q5' },
                    { value: '4', label: 'Tight Curls', trigger: 'Q5' },
                    { value: '5', label: 'Coily', trigger: 'Q5' }
                ]
            },
            {
                id: 'Q5',
                message: 'Is your hair texture:',
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                          steps["Q4-2"].message + " (P2)",
                          steps["A4-2"].message,
                          "Q4-2 (P2)"
                        );
                      }
                    return 'A5';
                }
            },
            {
                id: 'A5',
                options: [
                    { value: '1', label: 'Fine', trigger: 'Q5-2' },
                    { value: '2', label: 'Normal', trigger: 'Q5-2' },
                    { value: '3', label: 'Thick', trigger: 'Q5-2' },
                ]
            },
            {
                id: 'Q5-2',
                message: 'Is your hair thickness:',
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                          steps["Q5"].message + " (P2)",
                          steps["A5"].message,
                          "Q5 (P2)"
                        );
                    }
                    return 'A5-2';
                }
            },
            {
                id: 'A5-2',
                options:[
                    { value: '1', label: "Very Sparse", trigger: 'Q6' },
                    { value: '2', label: "Sparse", trigger: 'Q6' },
                    { value: '3', label: "Medium", trigger: 'Q6' },
                    { value: '4', label: "Thick", trigger: 'Q6' },
                    { value: '5', label: "Very Thick", trigger: 'Q6' }
                ]
            },
            {
                id: 'Q6',
                message: 'Do you tend to suffer from dandruff?',
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q5-2"].message + " (P2)",
                        steps["A5-2"].message,
                        "Q5-2 (P2)"
                        );
                    }
                    return 'A6';
                }
            },
            {
                id: 'A6',
                options:[
                    { value: '1', label: "Always", trigger: 'Q7' },
                    { value: '2', label: "Somewhat Often", trigger: 'Q7' },
                    { value: '3', label: "Sometimes", trigger: 'Q7' },
                    { value: '4', label: "Almost Never", trigger: 'Q7' }
                ]
            },
            {
                id: 'Q7',
                message: 'How many days does it take for your roots to become greasy?',
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q6"].message + " (P2)",
                        steps["A6"].message,
                        "Q6 (P2)"
                        );
                    }
                    return 'A7';
                }
            },
            {
                id: 'A7',
                options: [
                    { value: '1', label: 'Less than a day', trigger: 'Q8' },
                    { value: '2', label: '1 day', trigger: 'Q8' },
                    { value: '3', label: '2 days', trigger: 'Q8' },
                    { value: '4', label: '3 or more days', trigger: 'Q8' },
                    { value: '5', label: 'Does not become greasy', trigger: 'Q8' },
                ]
            },
            {
                id: 'Q8',
                message: "Is frizz a problem?",
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q7"].message + " (P2)",
                        steps["A7"].message,
                        "Q7 (P2)"
                        );
                    }
                    // this.updateStage(3);
                    return 'A8';
                }
            },
            {
                id: 'A8',
                options: [
                    { value: '1', label: 'No', trigger: 'Q8-1' },
                    { value: '2', label: 'Yes, only in high humidity', trigger: 'Q8-1' },
                    { value: '3', label: 'Yes, it becomes frizzy during the day', trigger: 'Q8-1' },
                    { value: '4', label: 'Yes, always', trigger: 'Q8-1' }
                ]
            },
            {
                id: 'Q8-1',
                message: "Has your hair been chemically treated recently?",
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q8"].message + " (P2)",
                        steps["A8"].message,
                        "Q8 (P2)"
                        );
                      }
                    return 'A8-1';
                }
            },
            {
                id: 'A8-1',
                options:[
                    { value: '1', label: "Color Treatment", trigger: 'Q8-2' },
                    { value: '2', label: "Chemical Treatment", trigger: 'Q8-2' },
                    { value: '3', label: "Both", trigger: 'Q8-2' },
                    { value: '4', label: "No, never", trigger: 'Q8-3' }
                ]
            },
            {
                id: 'Q8-2',
                message: "How often do you do these treatments?",
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q8-1"].message + " (P2)",
                        steps["A8-1"].message,
                        "Q8-1 (P2)"
                        );
                    }
                    return 'A8-2';
                }
            },
            {
                id: 'A8-2',
                options:[
                    { value: '1', label: "Every month", trigger: 'Q8-3' },
                    { value: '2', label: "Every couple of months", trigger: 'Q8-3' },
                    { value: '3', label: "Rarely", trigger: 'Q8-3' },
                    { value: '4', label: "Never", trigger: 'Q8-3' }
                ]
            },
            {
                id: 'Q8-3',
                message: "What's your daily style?",
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        steps["Q8-2"] && steps["Q8-2"].message + " (P2)" ?
                        aaUtil.event24_view_question(
                        steps["Q8-2"].message,
                        steps["A8-2"].message,
                        "Q8-2 (P2)"
                        ) :
                        aaUtil.event24_view_question(
                        steps["Q8-1"].message + " (P2)",
                        steps["A8-1"].message,
                        "Q8-1 (P2)"
                        ) 
                    }
                    this.updateStage(3);
                    return 'A8-3';
                }
            },
            {
                id: 'A8-3',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                        { key: '1', label: "Straight" },
                        { key: '2', label: "Wavy" },
                        { key: '3', label: "Braids" },
                        { key: '4', label: "Short" },
                        { key: '5', label: "Top Knot" },
                        { key: '6', label: "Updo" },
                        { key: '7', label: "Ponytail" },
                        { key: '8', label: "Curly" }
                    ]
                }
                />,
                waitAction: true,
                trigger: 'Q8-4'
            },
            {
                id: 'Q8-4',
                message: "How do you usually style your hair (we can recommend some heat protection options for you accordingly)?",
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q8-3"].message +  " (P2)",
                        steps["A8-3"].value.split(":")[1],
                        "Q8-3 (P2)"
                        );
                    }
                    return 'A8-4';
                }
            },
            {
                id: 'A8-4',
                options:[
                    { value: '1', label: "Curling iron", trigger: 'Q8-5' },
                    { value: '2', label: "Straightener", trigger: 'Q8-5' },
                    { value: '3', label: "Blow dryer", trigger: 'Q8-5' },
                    { value: '4', label: "Natural dry", trigger: 'Q8-5' }
                ]
            },
            {
                id: 'Q8-5',
                message: "What styling products do you use?",
                trigger: ({ value, steps }) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q8-4"].message +  " (P2)",
                        steps["A8-4"].message,
                        "Q8-4 (P2)"
                        );
                    }
                    return 'A8-5';
                }
            },
            {
                id: 'A8-5',
                component: <AthOnboardingMultiple
                  answerWidthCheck={this.state.width}
                  data={
                    [
                        { key: '1', label: "Styling cream" },
                        { key: '2', label: "Combing cream" },
                        { key: '3', label: "Hair spray" },
                        { key: '4', label: "Putty" },
                        { key: '5', label: "Wax" },
                        { key: '6', label: "Gel" },
                        { key: '7', label: "Hair mousse" },
                        // { key: '8', label: "Dry shampoo" },
                        { key: '9', label: "I don't use any products" }
                    ]
                  }
                />,
                waitAction: true,
                trigger: 'Q8-6'
            },
            {
                id: 'Q8-6',
                message: "Could you take a photo of your hair so we can better identify your hair conditions? Your photo is for analysis only and will be kept confidential.",
                trigger: ({value, steps}) => {
                    if (!localStorage.getItem("user_has_hair_profile")) {
                        aaUtil.event24_view_question(
                        steps["Q8-5"].message + " (P2)",
                        steps["A8-5"].value.split(":")[1],
                        "Q8-5 (P2)"
                    );
                    }
                    return 'A8-6';
                }
            },
            {
                id: 'A8-6',
                options: [
                    { value: '1', label: 'Take a photo', trigger: 'A8-6A' },
                    { value: '2', label: 'Skip', trigger: 'Q9' },
                ]
            },
            {
                id: 'A8-6A',
                component: <Picture answerWidthCheck={this.state.width} isAth={ true } />,
                waitAction: true,
                trigger: 'Q9'
            }
            // {
            //     id: 'Q8-9',
            //     message: "What would you like your hair routine to be?",
            //     trigger: ({ value, steps }) => {
            //         if (!localStorage.getItem("user_id")) {
            //             aaUtil.event24_view_question(
            //             steps["Q8-6"].message + " (P2)",
            //             steps["A8-6"].message,
            //             "Q8-6 (P2)"
            //             );
            //         }
            //         return 'A8-9';
            //     }
            // },
            // {
            //     id: 'A8-9',
            //     component: <AthOnboardingProducts answerWidthCheck={this.state.width} />,
            //     waitAction: true,
            //     trigger: 'Q9'
            // },

        ];

        let steps = [];
        if (localStorage.getItem("auth_token") && !localStorage.getItem("user_has_hair_profile")) {
            steps = startOfStepsWhenSigninHaveSkinProfile.concat(stepsOfSurveyAndSelfie).concat(endOfStepsWhenSignin);
        } else {
            if (localStorage.getItem("auth_token")) {
                steps = startOfStepsWhenSignin.concat(stepsOfSurveyAndSelfie).concat(endOfStepsWhenSignin);
            } else {
                steps = startOfStepsWhenNotSignin.concat(stepsOfSurveyAndSelfie).concat(endOfStepsWhenNotSignin);
            }
            
        }

        // const stage = this.state.stage;

        return (

                <ChatContainerWrapper id="onboarding-container-wrapper" className={"hair-onboarding-container-wrapper"} >
                    <Helmet>
                        <title>Onboarding Survey - HelloAva</title>
                         <meta name="description" content="What are your primary skin care concerns?  Answer Ava's questions to unlock your best skin care products and routine." />
                    </Helmet>
                    { this.state.width > 900 ? <HairSteps step={this.state.stage} /> : null}
                    <HairOnboarding steps={ steps }  />
                    { this.state.width <= 899 ? <HairSteps step={this.state.stage} /> : null}
                    {/*<AthSteps step={this.state.stage} />*/}
                </ChatContainerWrapper>
        );
    }
}

export default withRouter(connect()(HairOnboardingContainer))



// WEBPACK FOOTER //
// ./src/views/hair/onboarding/HairOnboardingContainer.js